<section >
  <ion-row class="header-row ion-align-items-center">
    <ion-col>
      <h3 class="popup-title">
     DWM Repository
      </h3>
    </ion-col>
    <ion-col size="auto">
      <button mat-icon-button mat-dialog-close class="close-btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </ion-col>
  </ion-row>

  <mat-dialog-content class="popup-content">
    <div class="mt-10">
      <div class="cardBox p-15">
    
        <!-- ================= Filters ================= -->
    
        <!-- <div class="phi-flex-wrap-center phi-gap-12 phi-justify-content-between">
          <div class="phi-flex-wrap-center phi-gap-12"
            <div>
  
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select Month" [(ngModel)]="selectedMonthForDWM">
                  <mat-option *ngFor="let month of monthsList" [value]="month">
                    {{ month }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="phi-flex-wrap-center phi-gap-12 button-group">
            <ion-button color="primary">
              <ion-icon name="copy-outline" slot="start" (click)="copyTask()"></ion-icon>
              Copy
            </ion-button>
     
    
          </div>
        </div>
    
   
    
    
        <!-- ================= Table ================= -->
        <div class="table-container mat-elevation-z1">
          <table mat-table [dataSource]="dwmData" class="mat-elevation-z2 dwm-table">
            <!-- Sr.No -->
            <ng-container matColumnDef="srNo">
              <th mat-header-cell *matHeaderCellDef>Sr.No</th>
              <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
            </ng-container>
    
            <!-- Category -->
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef>Category</th>
              <td mat-cell *matCellDef="let row">
                <span >{{ row.category }}</span>        
              </td>
            </ng-container>
    
    
    
            <!-- Actionable -->
            <ng-container matColumnDef="actionable">
              <th mat-header-cell *matHeaderCellDef>Actionable</th>
              <td mat-cell *matCellDef="let row">
                <span  matTooltipClass="custom-tooltip" [matTooltip]="row.actionable"
                matTooltipPosition="above" matTooltipShowDelay="300">{{ row.actionable | slice:0:12}}
                <span *ngIf="row.actionable?.length > 12">...</span></span>
              </td>
            </ng-container>
    
            <!-- Time From -->
            <ng-container matColumnDef="timeFrom">
              <th mat-header-cell *matHeaderCellDef>Time From</th>
              <td mat-cell *matCellDef="let row">
             <span>{{row.timeFrom}}</span>
              </td>
            </ng-container>
    
            <!-- Time To -->
            <ng-container matColumnDef="timeTo">
              <th mat-header-cell *matHeaderCellDef>Time To</th>
              <td mat-cell *matCellDef="let row">
                <span >{{ row.timeTo }}</span>
              </td>
            </ng-container>
    
    

               <!-- Duration -->
        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <span>{{ row.duration }}</span>
          </td>
        </ng-container>

            <ng-container matColumnDef="frequency">
              <th mat-header-cell *matHeaderCellDef>Frequency</th>
              <td mat-cell *matCellDef="let row">
                <span >{{ row.frequency }}</span>          
              </td>
            </ng-container>
    
    
            <!--  Calendor    -->
            <ng-container matColumnDef="calendor">
              <th mat-header-cell *matHeaderCellDef>Calendar</th>
              <td mat-cell *matCellDef="let row; let i = index">
    
                <!-- Hidden input + picker -->
                <mat-form-field style="display: none;">
                  <input matInput [matDatepicker]="picker" [(ngModel)]="row.calendor">
                  <mat-datepicker #picker [touchUi]="true" [panelClass]="'calendar-overlay'"></mat-datepicker>
    
                </mat-form-field>
    
                <!-- Open button -->
                <span>{{ row.calendor | date:'dd-MMM-yyyy' }}</span>
    
              </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
    
  
      </div>
    
    </div>
  </mat-dialog-content>
</section>
